//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Settings from 'gso-design-icons/vue/material-design/settings.vue';
import {read} from 'gso-session';
import resolveUrl from '../mixins/resolve-url';

export default {
	name: 'param-universe',
	components: {
		Settings
	},
	mixins: [resolveUrl],
	computed: {
		hasAccess() {
			var appAccessRigths = read('user').accessRights.find(app => {
				return app.application === 'paramuniverse';
			});
			return appAccessRigths.access !== 'denied';
		}
	},
	methods: {
		goToParamUniverse() {
			window.location = this.resolveUrl('../paramuniverse');
		}
	}
};
